export default __webpack_public_path__ + "static/helles-logo-53a77e62740cafa74fbac2c2784db8aa.svg";